import { Message } from "../message.model";

export type BodyAccessLogs =
  | {
      Tipo_consulta_BD: 'RANGO_MESES';
      mes_inicial: string;
      mes_final: string;
      sector: string;
      sucursal: string;
      fecha_periodo_anterior?: FechaPeriodoAnterior;
    }
  | {
      Tipo_consulta_BD: 'RANGO_DIAS';
      fecha_inicial: string;
      fecha_final: string;
      sector: string;
      sucursal: string;
      por_defecto?: string;
      fecha_periodo_anterior?: FechaPeriodoAnterior;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ACTUAL';
      anio_actual: string;
      sector: string;
      sucursal: string;
      fecha_periodo_anterior?: FechaPeriodoAnterior;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ANTERIOR';
      anio_anterior: string;
      sector: string;
      sucursal: string;
      fecha_periodo_anterior?: FechaPeriodoAnterior;
    }
  | {
      Tipo_consulta_BD: 'MES_ACTUAL';
      mes_actual: string;
      sector: string;
      sucursal: string;
      fecha_periodo_anterior?: FechaPeriodoAnterior;
    }
  | {
      Tipo_consulta_BD: 'MES_ANTERIOR';
      mes_anterior: string;
      sector: string;
      sucursal: string;
      fecha_periodo_anterior?: FechaPeriodoAnterior;
    };

export interface FechaPeriodoAnterior {
  fecha_inicial: string;
  fecha_final: string;
}


export interface ResponseAccessLogs {
  column_name: AccessLogsColumnName | Message;
}

export interface AccessLogsColumnName {
  "public data": DataAccessLogs;
}

export interface DataAccessLogs {
  anio_base: number,
  anio_anterior: number,
  accesos: AccessLog[];
  resumen: AccessLogSummary;
}

export interface AccessLog {
  Acceso: string;
  Entradas: number;
  Salidas: number;
  Entradas_periodo_anterior: number;
}

export interface AccessLogSummary {
  total_visitantes: number;
  total_visitantes_anterior: number;
  diferencia: number;
  porcentaje: string;
  indicador: string;
}
